import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

export function useNetworkState() {
  const [isOnline, setOnline] = useState(true);

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    function handleOnline() {
      setOnline(true);
    }

    function handleOffline() {
      setOnline(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
